import styled from 'styled-components';
export var Recenter = styled.button.withConfig({
  displayName: "elements__Recenter",
  componentId: "sc-14hijqw-0"
})(["left:0;position:absolute;top:0;"]);
export var Root = styled.div.withConfig({
  displayName: "elements__Root",
  componentId: "sc-14hijqw-1"
})(["margin:3rem 0;position:relative;"]);
export var ScrollArea = styled.div.withConfig({
  displayName: "elements__ScrollArea",
  componentId: "sc-14hijqw-2"
})(["height:", ";overflow:auto;position:relative;"], function (_ref) {
  var height = _ref.height;
  return "".concat(height, "px");
});
export var ScrollContent = styled.div.withConfig({
  displayName: "elements__ScrollContent",
  componentId: "sc-14hijqw-3"
})(["background-color:", ";align-items:center;display:flex;height:", ";justify-content:center;width:200vw;"], function (_ref2) {
  var palette = _ref2.theme.palette;
  return palette.veryLightBlue;
}, function (_ref3) {
  var height = _ref3.height;
  return "".concat(height + 500, "px");
});